// External deps
import PropTypes from 'prop-types';
import { Row, Col, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { Label } from 'ypf-pas-general-ui-components';
import { BsFillExclamationCircleFill } from 'react-icons/bs';

// Internal deps
import './AccountAssignmentObjectDetail.scss';

const AccountAssignmentObjectDetail = ({ data, societyLabel }) => {
  const labelEstado = 'Estado';
  const renderTooltip = (propsTooltip) => (
    <Tooltip id="button-tooltip" {...propsTooltip}>
      {data.description}
    </Tooltip>
  );

  const showSociety = () => {
    const society = data.soc;

    if (Array.isArray(society)) {
      return society.map((soc) => (
        <img alt="society-img" className="society-img" key={soc} src={soc} />
      ));
    }

    return '-';
  };

  return (
    <Row>
      <Col sm={2}>
        <OverlayTrigger
          delay={{
            show: 250,
            hide: 400
          }}
          overlay={renderTooltip}
          placement="top"
        >
          <div>
            <Label
              icon={data.warningState ? BsFillExclamationCircleFill : null}
              iconPosition="left"
              iconWarning={data.warningState}
              label={labelEstado}
              size="md"
              sizeValue="md"
              value={data.state}
              variant="light"
            />
          </div>
        </OverlayTrigger>
        {societyLabel && (
          <Label
            label="Sociedad"
            size="md"
            sizeValue="md"
            value={<div className="detail society">{showSociety()}</div>}
            variant="light"
          />
        )}
      </Col>
      <Col sm={1} />
      <Col sm={3}>
        <Label
          icon={data.warningBudget ? BsFillExclamationCircleFill : null}
          iconPosition="left"
          iconWarning={data.warningBudget}
          label="Presupuesto disponible"
          size="md"
          sizeValue="md"
          value={`${data.budget ? `U$D ${data.budget}` : '-'}`}
          variant="light"
        />
      </Col>
      <Col sm={3}>
        <Label
          label="Centro logístico"
          size="md"
          sizeValue="md"
          value={data.logisticCenter || '-'}
          variant="light"
        />
      </Col>
      <Col sm={3}>
        <Label
          label="Código de sociedad"
          size="md"
          sizeValue="md"
          value={data.socCode || '-'}
          variant="light"
        />
      </Col>
    </Row>
  );
};

AccountAssignmentObjectDetail.propTypes = {
  data: PropTypes.shape({
    description: PropTypes.string,
    state: PropTypes.string,
    budget: PropTypes.number,
    logisticCenter: PropTypes.string,
    socCode: PropTypes.string,
    soc: PropTypes.arrayOf(PropTypes.string),
    warningBudget: PropTypes.bool,
    warningState: PropTypes.bool
  }),
  societyLabel: PropTypes.bool
};
AccountAssignmentObjectDetail.defaultProps = {
  data: {
    description: '-',
    state: '-',
    budget: null,
    logisticCenter: '-',
    socCode: '-',
    soc: [],
    warningBudget: false,
    warningState: false
  },
  societyLabel: true
};

export default AccountAssignmentObjectDetail;
